import type {
	SelectedTransport,
	SelectedTransportResponse,
	SelectedV2Transport,
	SelectedV2TransportResponse,
} from './transport.types';

export const mapToSelectedTransportResponse = (selectedOption: SelectedTransport): SelectedTransportResponse => {
	return {
		price: selectedOption.price,
		type: selectedOption.transportType,
	};
};

export const mapToSelectedV2TransportResponse = (selectedOption: SelectedV2Transport): SelectedV2TransportResponse => {
	return {
		price: selectedOption.price,
		site: selectedOption.dealerDetails.site,
		type: selectedOption.transportType,
	};
};
